module.exports = __webpack_public_path__ + "static/media/mail-light.7a3cb7c0.svg";